import React from 'react';
import {
  number, shape, arrayOf, string, func
} from 'prop-types';
import { RadioGroup, Radio, SelectionControlLabel } from '@one-thd/sui-atomic-components';
import { ACCESSORIES } from '../constants/index';

export const SelectableVarientRadio = ({ selectableVarient, handleChange, value, productCategory }) => {
  return (
    <div className="sui-flex sui-gap-1" data-testid="selectable-variant-radio">
      <RadioGroup
        aria-labelledby="bundle-selectable-variants"
        value={value}
        name="bundle-selectable-variants"
        onChange={(event) => handleChange(event?.target?.value)}
      >
        {selectableVarient?.map((variant) => (
          <SelectionControlLabel key={variant?.id} value={variant?.id} label={variant?.value}>
            <Radio />
          </SelectionControlLabel>
        ))}
      </RadioGroup>
    </div>
  );
};

SelectableVarientRadio.displayName = 'SelectableVarientRadio';

SelectableVarientRadio.propTypes = {
  selectableVarient: arrayOf(
    shape({
      id: number.isRequired,
      value: string.isRequired
    })
  ).isRequired,
  handleChange: func.isRequired,
  value: string.isRequired,
  productCategory: string.isRequired
};